import React from "react";

const Lights: React.FC = () => {
  return (
    <svg
      className="w-full"
      id="lights"
      width="947"
      height="861"
      viewBox="0 0 947 861"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <g filter="url(#filter0_f_1439_296)">
          <circle
            cx="216.499"
            cy="336.5"
            r="71.5"
            fill="url(#paint0_linear_1439_296)"
            fillOpacity="0.5"
          />
          <circle cx="216.499" cy="336.5" r="71" stroke="#EBD69C" />
        </g>
        <g filter="url(#filter1_f_1439_296)">
          <circle
            cx="306.647"
            cy="359.648"
            r="71.5"
            transform="rotate(16.2463 306.647 359.648)"
            fill="url(#paint1_linear_1439_296)"
            fillOpacity="0.5"
          />
          <circle
            cx="306.647"
            cy="359.648"
            r="71"
            transform="rotate(16.2463 306.647 359.648)"
            stroke="#EBD69C"
          />
        </g>
      </g>
      <g opacity="0.5">
        <g filter="url(#filter2_f_1439_296)">
          <circle
            cx="300.414"
            cy="421.871"
            r="71.5"
            transform="rotate(114.056 300.414 421.871)"
            fill="url(#paint2_linear_1439_296)"
            fillOpacity="0.5"
          />
          <circle
            cx="300.414"
            cy="421.871"
            r="71"
            transform="rotate(114.056 300.414 421.871)"
            stroke="#EBD69C"
          />
        </g>
        <g filter="url(#filter3_f_1439_296)">
          <circle
            cx="89.7761"
            cy="533.777"
            r="71.5"
            transform="rotate(130.303 89.7761 533.777)"
            fill="url(#paint3_linear_1439_296)"
            fillOpacity="0.5"
          />
          <circle
            cx="89.7761"
            cy="533.777"
            r="71"
            transform="rotate(130.303 89.7761 533.777)"
            stroke="#EBD69C"
          />
        </g>
      </g>
      <g opacity="0.5">
        <g filter="url(#filter4_f_1439_296)">
          <circle
            cx="666.97"
            cy="146.859"
            r="71.5"
            transform="rotate(114.056 666.97 146.859)"
            fill="url(#paint4_linear_1439_296)"
            fillOpacity="0.5"
          />
          <circle
            cx="666.97"
            cy="146.859"
            r="71"
            transform="rotate(114.056 666.97 146.859)"
            stroke="#EBD69C"
          />
        </g>
        <g filter="url(#filter5_f_1439_296)">
          <circle
            cx="517.434"
            cy="662.437"
            r="71.5"
            transform="rotate(114.056 517.434 662.437)"
            fill="url(#paint5_linear_1439_296)"
            fillOpacity="0.5"
          />
          <circle
            cx="517.434"
            cy="662.437"
            r="71"
            transform="rotate(114.056 517.434 662.437)"
            stroke="#EBD69C"
          />
        </g>
        <g filter="url(#filter6_f_1439_296)">
          <circle
            cx="561.776"
            cy="117.773"
            r="71.5"
            transform="rotate(130.303 561.776 117.773)"
            fill="url(#paint6_linear_1439_296)"
            fillOpacity="0.5"
          />
          <circle
            cx="561.776"
            cy="117.773"
            r="71"
            transform="rotate(130.303 561.776 117.773)"
            stroke="#EBD69C"
          />
        </g>
        <g filter="url(#filter7_f_1439_296)">
          <circle
            cx="703.775"
            cy="326.777"
            r="71.5"
            transform="rotate(130.303 703.775 326.777)"
            fill="url(#paint7_linear_1439_296)"
            fillOpacity="0.5"
          />
          <circle
            cx="703.775"
            cy="326.777"
            r="71"
            transform="rotate(130.303 703.775 326.777)"
            stroke="#EBD69C"
          />
        </g>
        <g filter="url(#filter8_f_1439_296)">
          <circle
            cx="581.775"
            cy="790.777"
            r="71.5"
            transform="rotate(130.303 581.775 790.777)"
            fill="url(#paint8_linear_1439_296)"
            fillOpacity="0.5"
          />
          <circle
            cx="581.775"
            cy="790.777"
            r="71"
            transform="rotate(130.303 581.775 790.777)"
            stroke="#EBD69C"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_1439_296"
          x="121.999"
          y="242"
          width="189"
          height="189"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="11.5"
            result="effect1_foregroundBlur_1439_296"
          />
        </filter>
        <filter
          id="filter1_f_1439_296"
          x="225.129"
          y="278.129"
          width="163.037"
          height="163.039"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5"
            result="effect1_foregroundBlur_1439_296"
          />
        </filter>
        <filter
          id="filter2_f_1439_296"
          x="205.896"
          y="327.352"
          width="189.035"
          height="189.035"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="11.5"
            result="effect1_foregroundBlur_1439_296"
          />
        </filter>
        <filter
          id="filter3_f_1439_296"
          x="8.27441"
          y="452.277"
          width="163.003"
          height="163"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5"
            result="effect1_foregroundBlur_1439_296"
          />
        </filter>
        <filter
          id="filter4_f_1439_296"
          x="572.452"
          y="52.3398"
          width="189.035"
          height="189.035"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="11.5"
            result="effect1_foregroundBlur_1439_296"
          />
        </filter>
        <filter
          id="filter5_f_1439_296"
          x="422.917"
          y="567.918"
          width="189.035"
          height="189.035"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="11.5"
            result="effect1_foregroundBlur_1439_296"
          />
        </filter>
        <filter
          id="filter6_f_1439_296"
          x="480.274"
          y="36.2734"
          width="163.003"
          height="163"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5"
            result="effect1_foregroundBlur_1439_296"
          />
        </filter>
        <filter
          id="filter7_f_1439_296"
          x="622.273"
          y="245.277"
          width="163.003"
          height="163"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5"
            result="effect1_foregroundBlur_1439_296"
          />
        </filter>
        <filter
          id="filter8_f_1439_296"
          x="500.273"
          y="709.277"
          width="163.003"
          height="163"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="5"
            result="effect1_foregroundBlur_1439_296"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1439_296"
          x1="216.499"
          y1="265"
          x2="216.499"
          y2="408"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBD69C" />
          <stop offset="1" stopColor="#A17601" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1439_296"
          x1="306.647"
          y1="288.148"
          x2="306.647"
          y2="431.148"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5A31A" />
          <stop offset="1" stopColor="#FFEDBD" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1439_296"
          x1="300.414"
          y1="350.371"
          x2="300.414"
          y2="493.371"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBD69C" />
          <stop offset="1" stopColor="#A17601" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1439_296"
          x1="89.7761"
          y1="462.277"
          x2="89.7761"
          y2="605.277"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5A31A" />
          <stop offset="1" stopColor="#FFEDBD" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1439_296"
          x1="666.97"
          y1="75.359"
          x2="666.97"
          y2="218.359"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBD69C" />
          <stop offset="1" stopColor="#A17601" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1439_296"
          x1="517.434"
          y1="590.937"
          x2="517.434"
          y2="733.937"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EBD69C" />
          <stop offset="1" stopColor="#A17601" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1439_296"
          x1="561.776"
          y1="46.2731"
          x2="561.776"
          y2="189.273"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5A31A" />
          <stop offset="1" stopColor="#FFEDBD" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1439_296"
          x1="703.775"
          y1="255.277"
          x2="703.775"
          y2="398.277"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D5A31A" />
          <stop offset="1" stopColor="#FFEDBD" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1439_296"
          x1="581.775"
          y1="719.277"
          x2="581.775"
          y2="862.277"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC72C" />
          <stop offset="1" stopColor="#FFEDBD" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Lights;
